module.exports = __webpack_public_path__ + "static/media/Folder.05689777.svg";